import { z } from 'zod';

export const CoreCommunicationSocialMediaIntegrationScalarFieldEnumSchema = z.enum(['id','cityId','createdAt','updatedAt','deactivatedAt','deletedAt','accountName','adminNotes','accountProfileImageFileId','status']);

export default CoreCommunicationSocialMediaIntegrationScalarFieldEnumSchema;
